"use strict";
/*
 * HSDataTable
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSDataTable = /** @class */ (function (_super) {
    __extends(HSDataTable, _super);
    function HSDataTable(el, options, events) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        var _this = _super.call(this, el, options, events) || this;
        _this.el = typeof el === 'string' ? document.querySelector(el) : el;
        // Exclude columns from ordering
        var columnDefs = [];
        Array.from(_this.el.querySelectorAll('thead th, thead td')).forEach(function (th, ind) {
            if (th.classList.contains('--exclude-from-ordering'))
                columnDefs.push({
                    targets: ind,
                    orderable: false,
                });
        });
        var data = _this.el.getAttribute('data-hs-datatable');
        var dataOptions = data ? JSON.parse(data) : {};
        _this.concatOptions = __assign(__assign({ searching: true, lengthChange: false, order: [], columnDefs: __spreadArray([], columnDefs, true) }, dataOptions), options);
        _this.table = _this.el.querySelector('table');
        _this.search = (_a = _this.el.querySelector('[data-hs-datatable-search]')) !== null && _a !== void 0 ? _a : null;
        _this.pageEntities =
            (_b = _this.el.querySelector('[data-hs-datatable-page-entities]')) !== null && _b !== void 0 ? _b : null;
        _this.paging = (_c = _this.el.querySelector('[data-hs-datatable-paging]')) !== null && _c !== void 0 ? _c : null;
        _this.pagingPrev =
            (_d = _this.el.querySelector('[data-hs-datatable-paging-prev]')) !== null && _d !== void 0 ? _d : null;
        _this.pagingNext =
            (_e = _this.el.querySelector('[data-hs-datatable-paging-next]')) !== null && _e !== void 0 ? _e : null;
        _this.pagingPages =
            (_f = _this.el.querySelector('[data-hs-datatable-paging-pages]')) !== null && _f !== void 0 ? _f : null;
        _this.info = (_g = _this.el.querySelector('[data-hs-datatable-info]')) !== null && _g !== void 0 ? _g : null;
        _this.infoFrom =
            (_h = _this.el.querySelector('[data-hs-datatable-info-from]')) !== null && _h !== void 0 ? _h : null;
        _this.infoTo = (_j = _this.el.querySelector('[data-hs-datatable-info-to]')) !== null && _j !== void 0 ? _j : null;
        _this.infoLength =
            (_k = _this.el.querySelector('[data-hs-datatable-info-length]')) !== null && _k !== void 0 ? _k : null;
        if ((_l = _this.concatOptions) === null || _l === void 0 ? void 0 : _l.rowSelectingOptions)
            _this.rowSelectingAll =
                (_r = (((_o = (_m = _this.concatOptions) === null || _m === void 0 ? void 0 : _m.rowSelectingOptions) === null || _o === void 0 ? void 0 : _o.selectAllSelector)
                    ? document.querySelector((_q = (_p = _this.concatOptions) === null || _p === void 0 ? void 0 : _p.rowSelectingOptions) === null || _q === void 0 ? void 0 : _q.selectAllSelector)
                    : document.querySelector('[data-hs-datatable-row-selecting-all]'))) !== null && _r !== void 0 ? _r : null;
        if ((_s = _this.concatOptions) === null || _s === void 0 ? void 0 : _s.rowSelectingOptions)
            _this.rowSelectingIndividual =
                (_w = (_v = (_u = (_t = _this.concatOptions) === null || _t === void 0 ? void 0 : _t.rowSelectingOptions) === null || _u === void 0 ? void 0 : _u.individualSelector) !== null && _v !== void 0 ? _v : '[data-hs-datatable-row-selecting-individual]') !== null && _w !== void 0 ? _w : null;
        if (_this.pageEntities)
            _this.concatOptions.pageLength = parseInt(_this.pageEntities.value);
        _this.maxPagesToShow = 3;
        _this.isRowSelecting = !!((_x = _this.concatOptions) === null || _x === void 0 ? void 0 : _x.rowSelectingOptions);
        _this.pageBtnClasses =
            (_0 = (_z = (_y = _this.concatOptions) === null || _y === void 0 ? void 0 : _y.pagingOptions) === null || _z === void 0 ? void 0 : _z.pageBtnClasses) !== null && _0 !== void 0 ? _0 : null;
        _this.init();
        return _this;
    }
    HSDataTable.prototype.init = function () {
        this.createCollection(window.$hsDataTableCollection, this);
        this.initTable();
        if (this.search)
            this.initSearch();
        if (this.pageEntities)
            this.initPageEntities();
        if (this.paging)
            this.initPaging();
        if (this.pagingPrev)
            this.initPagingPrev();
        if (this.pagingNext)
            this.initPagingNext();
        if (this.pagingPages)
            this.buildPagingPages();
        if (this.info)
            this.initInfo();
        if (this.isRowSelecting)
            this.initRowSelecting();
    };
    HSDataTable.prototype.initTable = function () {
        var _this = this;
        this.dataTable = new DataTable(this.table, this.concatOptions);
        if (this.isRowSelecting)
            this.triggerChangeEventToRow();
        this.dataTable.on('draw', function () {
            if (_this.isRowSelecting)
                _this.updateSelectAllCheckbox();
            if (_this.isRowSelecting)
                _this.triggerChangeEventToRow();
            _this.updateInfo();
            _this.updatePaging();
        });
    };
    // Search
    HSDataTable.prototype.initSearch = function () {
        var _this = this;
        this.search.addEventListener('input', (0, utils_1.debounce)(function (evt) {
            return _this.onSearchInput(evt.target.value);
        }));
    };
    HSDataTable.prototype.onSearchInput = function (val) {
        this.dataTable.search(val).draw();
    };
    // Page entities
    HSDataTable.prototype.initPageEntities = function () {
        var _this = this;
        this.pageEntities.addEventListener('change', function (evt) {
            return _this.onEntitiesChange(parseInt(evt.target.value));
        });
    };
    HSDataTable.prototype.onEntitiesChange = function (entities) {
        this.dataTable.page.len(entities).draw();
    };
    // Info
    HSDataTable.prototype.initInfo = function () {
        if (this.infoFrom)
            this.initInfoFrom();
        if (this.infoTo)
            this.initInfoTo();
        if (this.infoLength)
            this.initInfoLength();
    };
    HSDataTable.prototype.initInfoFrom = function () {
        var start = this.dataTable.page.info().start;
        this.infoFrom.innerText = "".concat(start + 1);
    };
    HSDataTable.prototype.initInfoTo = function () {
        var end = this.dataTable.page.info().end;
        this.infoTo.innerText = "".concat(end);
    };
    HSDataTable.prototype.initInfoLength = function () {
        var recordsTotal = this.dataTable.page.info().recordsTotal;
        this.infoLength.innerText = "".concat(recordsTotal);
    };
    HSDataTable.prototype.updateInfo = function () {
        this.initInfo();
    };
    // Paging
    HSDataTable.prototype.initPaging = function () {
        this.hidePagingIfSinglePage();
    };
    HSDataTable.prototype.hidePagingIfSinglePage = function () {
        var pages = this.dataTable.page.info().pages;
        if (pages < 2) {
            this.paging.classList.add('hidden');
            this.paging.style.display = 'none';
        }
        else {
            this.paging.classList.remove('hidden');
            this.paging.style.display = '';
        }
    };
    HSDataTable.prototype.initPagingPrev = function () {
        var _this = this;
        this.pagingPrev.addEventListener('click', function () {
            _this.onPrevClick();
        });
    };
    HSDataTable.prototype.onPrevClick = function () {
        this.dataTable.page('previous').draw('page');
    };
    HSDataTable.prototype.disablePagingArrow = function (el, statement) {
        if (statement) {
            el.classList.add('disabled');
            el.setAttribute('disabled', 'disabled');
        }
        else {
            el.classList.remove('disabled');
            el.removeAttribute('disabled');
        }
    };
    HSDataTable.prototype.initPagingNext = function () {
        var _this = this;
        this.pagingNext.addEventListener('click', function () {
            _this.onNextClick();
        });
    };
    HSDataTable.prototype.onNextClick = function () {
        this.dataTable.page('next').draw('page');
    };
    HSDataTable.prototype.buildPagingPages = function () {
        this.updatePaging();
    };
    HSDataTable.prototype.updatePaging = function () {
        var _a = this.dataTable.page.info(), page = _a.page, pages = _a.pages, length = _a.length;
        var totalRecords = this.dataTable.rows({ search: 'applied' }).count();
        var totalPages = Math.ceil(totalRecords / length);
        var currentPage = page + 1;
        var startPage = Math.max(1, currentPage - Math.floor(this.maxPagesToShow / 2));
        var endPage = Math.min(totalPages, startPage + (this.maxPagesToShow - 1));
        if (endPage - startPage + 1 < this.maxPagesToShow) {
            startPage = Math.max(1, endPage - this.maxPagesToShow + 1);
        }
        this.pagingPages.innerHTML = '';
        if (startPage > 1) {
            this.buildPagingPage(1);
            if (startPage > 2) {
                this.pagingPages.appendChild((0, utils_1.htmlToElement)("<span class=\"ellipsis\">...</span>"));
            }
        }
        for (var i = startPage; i <= endPage; i++) {
            this.buildPagingPage(i);
        }
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                this.pagingPages.appendChild((0, utils_1.htmlToElement)("<span class=\"ellipsis\">...</span>"));
            }
            this.buildPagingPage(totalPages);
        }
        this.disablePagingArrow(this.pagingPrev, page === 0);
        this.disablePagingArrow(this.pagingNext, page === pages - 1);
        this.hidePagingIfSinglePage();
    };
    HSDataTable.prototype.buildPagingPage = function (counter) {
        var _this = this;
        var page = this.dataTable.page.info().page;
        var pageEl = (0, utils_1.htmlToElement)("<button type=\"button\"></button>");
        pageEl.innerText = "".concat(counter);
        pageEl.setAttribute('data-page', "".concat(counter));
        if (this.pageBtnClasses)
            (0, utils_1.classToClassList)(this.pageBtnClasses, pageEl);
        if (page === counter - 1)
            pageEl.classList.add('active');
        pageEl.addEventListener('click', function () { return _this.onPageClick(counter); });
        this.pagingPages.append(pageEl);
    };
    HSDataTable.prototype.onPageClick = function (counter) {
        this.dataTable.page(counter - 1).draw('page');
    };
    // Select row
    HSDataTable.prototype.initRowSelecting = function () {
        var _this = this;
        this.rowSelectingAll.addEventListener('change', function () {
            return _this.onSelectAllChange();
        });
    };
    HSDataTable.prototype.triggerChangeEventToRow = function () {
        var _this = this;
        this.table
            .querySelectorAll("tbody ".concat(this.rowSelectingIndividual))
            .forEach(function (el) {
            el.addEventListener('change', function () {
                _this.updateSelectAllCheckbox();
            });
        });
    };
    HSDataTable.prototype.onSelectAllChange = function () {
        var _this = this;
        var isChecked = this.rowSelectingAll.checked;
        var visibleRows = Array.from(this.dataTable.rows({ page: 'current', search: 'applied' }).nodes());
        visibleRows.forEach(function (el) {
            var checkbox = el.querySelector(_this.rowSelectingIndividual);
            if (checkbox)
                checkbox.checked = isChecked;
        });
        this.updateSelectAllCheckbox();
    };
    HSDataTable.prototype.updateSelectAllCheckbox = function () {
        var _this = this;
        var searchRelatedItems = this.dataTable
            .rows({ search: 'applied' })
            .count();
        if (!searchRelatedItems) {
            this.rowSelectingAll.checked = false;
            return false;
        }
        var isChecked = true;
        var visibleRows = Array.from(this.dataTable
            .rows({
            page: 'current',
            search: 'applied',
        })
            .nodes());
        visibleRows.forEach(function (el) {
            var checkbox = el.querySelector(_this.rowSelectingIndividual);
            if (checkbox && !checkbox.checked) {
                isChecked = false;
                return false;
            }
        });
        this.rowSelectingAll.checked = isChecked;
    };
    // Static methods
    HSDataTable.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsDataTableCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element.el
            : null;
    };
    HSDataTable.autoInit = function () {
        if (!window.$hsDataTableCollection)
            window.$hsDataTableCollection = [];
        document
            .querySelectorAll('[data-hs-datatable]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsDataTableCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSDataTable(el);
        });
    };
    return HSDataTable;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    if (document.querySelectorAll('[data-hs-datatable]:not(.--prevent-on-load-init)').length) {
        if (typeof jQuery === 'undefined')
            console.error('HSDataTable: jQuery is not available, please add it to the page.');
        if (typeof DataTable === 'undefined')
            console.error('HSDataTable: DataTable is not available, please add it to the page.');
    }
    if (typeof DataTable !== 'undefined' && typeof jQuery !== 'undefined')
        HSDataTable.autoInit();
    // Uncomment for debug
    // console.log('Datatable collection:', window.$hsDataTableCollection);
});
if (typeof window !== 'undefined') {
    window.HSDataTable = HSDataTable;
}
exports.default = HSDataTable;
